<template>
  <b-form id="mileage-search-form">
    <b-alert variant="danger" :show="mileageSearchHasError"><strong>Uwaga.</strong> Formularz zawiera błędy.</b-alert>
    <b-form-group label="Numer drogi" label-for="road-number-input">
      <small class="text-danger" v-show="mileageSearchErrors.mileageRoadNumberIsEmpty">Należy podać numer drogi.</small>
      <autocomplete
      ref= "autocompleteRoad"
      id="road-number-input"
      v-model="mileageRoadNumber" 
      :items="roadNumberAutocompleteItems"
      @item-selected="roadNumberAutocompleteItemSelected"
      @update-items="roadAutocompleteUpdated" 
      :get-label="getAutocompleteLabel"
      :input-attrs="{ 'placeholder': 'Wyszukaj numer drogi', 'class': 'form-control' }"
      :min-len="0" 
      :auto-select-one-item="false">
      </autocomplete>
    </b-form-group>
    <b-form-group label="Kilometraż" label-for="mileage-value-input">
      <small class="text-danger" v-show="mileageSearchErrors.mileageValueIsEmpty">Należy podać kilometraż.</small>
      <b-form-input id="mileage-value-input" v-model="mileageValue" type="number" min="0" :class="{ 'is-invalid': mileageSearchErrors.mileageValueIsEmpty, 'form-control': true }"></b-form-input>
    </b-form-group>
    <b-form-group>
      <b-btn @click="submitMileageSearch()" variant="primary" class="col-md-12" size="sm" :disabled="submittingMileageSearch">
        <span v-show="!submittingMileageSearch">Szukaj</span>
        <icon v-show="submittingMileageSearch" name="circle-notch" spin></icon>
      </b-btn>
    </b-form-group>
  </b-form>
</template>

<script>
import Autocomplete from 'v-autocomplete';
import {
  SEARCH_LOADER_SHOW,
  SEARCH_LOADER_HIDE
} from '../../store/mutations.type';
import {
  SEARCH_MILEAGE_GET, SEARCH_ROAD_GET
} from '../../store/actions.type';
export default {
  name: "MileageSearch",
  components:{
    Autocomplete
  },
  data() {
    return {      
      mileageSearchErrors: {
        mileageRoadNumberIsEmpty: false,
        mileageValueIsEmpty: false,
      },
      mileageRoadNumber: null,
      mileageValue: "",
      submittingMileageSearch: false,
      roadSearchControl: null,
      roadNumberAutocompleteItems:[],
      selectedRoad: undefined
    }
  },
  methods: {
    submitMileageSearch() {
      if(this.isValid()) {
        this.submit();
      }
    },
    isValid() {
      this.mileageSearchErrors.mileageRoadNumberIsEmpty = !this.mileageRoadNumber;
      this.mileageSearchErrors.mileageValueIsEmpty = !this.mileageValue;

      if(this.mileageSearchHasError)
        return false;
      return true;
    },
    submit() {     
      this.$store.dispatch(SEARCH_MILEAGE_GET, { mileageRoadNumber: this.mileageRoadNumber, mileageValue: this.mileageValue });
    },
    roadNumberAutocompleteItemSelected(item){
      this.selectedRoad=item;
    },
    async roadAutocompleteUpdated(text){  
      this.$store.commit(SEARCH_LOADER_SHOW);
      this.roadSearchControl=Date.now();
      var response = await this.$store.dispatch(SEARCH_ROAD_GET, { text: text, control: this.roadSearchControl });
      if(response && response.control == this.roadSearchControl.toString()) {
          this.roadNumberAutocompleteItems=response.drogi.map(item=>item.numer_drogi);
        }
      this.$store.commit(SEARCH_LOADER_HIDE);
    },
    getAutocompleteLabel(item){
      if(item!=null){
        return item;
      }
      return this.$refs.autocompleteRoad.searchText;
    }
  },
  computed: {
    mileageSearchHasError() {
      return this.mileageSearchErrors.mileageRoadNumberIsEmpty ||
             this.mileageSearchErrors.mileageValueIsEmpty;
    }
  }
}
</script>

